import { render, staticRenderFns } from "./PkHeader.vue?vue&type=template&id=1d79e8c7"
import script from "./PkHeader.vue?vue&type=script&lang=js"
export * from "./PkHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports